module.exports = __webpack_public_path__ + "static/media/privacy.c471ad05.jpg";